import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Input,
  ModalHeader,
  ModalBody,
  Label,
  ModalFooter,
  Modal,
  Form,
  Button
} from "reactstrap";
import InputMask from "react-input-mask";
import { useFeira } from "../Contexts/FeiraContext";
import { toast } from "react-toastify";
import { api } from "../config";

const ModalQueroExpor = ({ idFeira, isOpen, toggle, paises: propPaises }) => {
  const context = useFeira() || {}; 
  const { openModalQueroExpor, setOpenModalQueroExpor, paises: contextPaises = [] } = context;
  const listaPaisesFinal = propPaises || contextPaises;
  const isModalOpen = isOpen !== undefined ? isOpen : openModalQueroExpor;
  
  const handleClose = () => {
    if (toggle) toggle();
    if (setOpenModalQueroExpor) setOpenModalQueroExpor(false);
  };

  const [formData, setFormData] = useState({});
  const [isBrasil, setIsBrasil] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModalConfirmado, setShowModalConfirmado] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (formData.pais === "BR") setIsBrasil(true);
    else setIsBrasil(false);
  }, [formData.pais]);

  useEffect(() => {
    if (!openModalQueroExpor) {
      setFormData({});
      setIsBrasil(false);
      setShowModalConfirmado(false);
      setErrors({});
    }
  }, [openModalQueroExpor]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
    // Limpa o erro quando o campo é alterado
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const buscarEndereco = async (cepDigitado) => {
    try {
      const resposta = await fetch(`https://viacep.com.br/ws/${cepDigitado}/json/`);
      const dados = await resposta.json();
      if (!dados.erro) {
        setFormData((prev) => ({
          ...prev,
          estado: dados.uf,
          rua: dados.logradouro, 
          bairro: dados.bairro,
          cidade: dados.localidade
        }));
      }
    } catch (error) {
      console.error("Erro ao buscar o CEP:", error);
    }
  };

  const handleCepChange = (e) => {
    const novoCep = e.target.value.replace(/\D/g, '');
    handleChange({ target: { name: "cep", value: novoCep } });

    if (novoCep.length === 8) {
      buscarEndereco(novoCep);
    }
  };

  const validarCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (cnpj.length !== 14) return false;
    if (/^(\d)\1+$/.test(cnpj)) return false;

    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(0))) return false;

    tamanho++;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    return resultado === parseInt(digitos.charAt(1));
  };

  const validarEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const validarCampos = () => {
    const newErrors = {};
    let isValid = true;

    // Campos obrigatórios para todos os países
    if (!formData.nome_expositor?.trim()) {
      newErrors.nome_expositor = "Nome da empresa é obrigatório";
      isValid = false;
    }

    if (!formData.pais) {
      newErrors.pais = "País é obrigatório";
      isValid = false;
    }

    if (isBrasil) {
      if (!formData.cnpj?.trim()) {
        newErrors.cnpj = "CNPJ é obrigatório";
        isValid = false;
      } else if (!validarCNPJ(formData.cnpj)) {
        newErrors.cnpj = "CNPJ inválido";
        isValid = false;
      }
    } 
    
    if (!formData.email?.trim()) {
      newErrors.email = "E-mail é obrigatório";
      isValid = false;
    } else if (!validarEmail(formData.email)) {
      newErrors.email = "E-mail inválido";
      isValid = false;
    }

    if (!formData.telefone?.trim()) {
      newErrors.telefone = "Telefone é obrigatório";
      isValid = false;
    }

    // Campos obrigatórios apenas para Brasil
    if (isBrasil) {
      if (!formData.cep?.trim()) {
        newErrors.cep = "CEP é obrigatório";
        isValid = false;
      }
      if (!formData.cidade?.trim()) {
        newErrors.cidade = "Cidade é obrigatória";
        isValid = false;
      }
      if (!formData.estado?.trim()) {
        newErrors.estado = "Estado é obrigatório";
        isValid = false;
      }
      if (!formData.rua?.trim()) {
        newErrors.rua = "Rua é obrigatória";
        isValid = false;
      }
      if (!formData.bairro?.trim()) {
        newErrors.bairro = "Bairro é obrigatório";
        isValid = false;
      }
      if (!formData.numero?.trim()) {
        newErrors.numero = "Número é obrigatório";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validarCampos()) {
      toast.error("Por favor, preencha todos os campos obrigatórios corretamente");
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${api.API_URL}/lista-espera`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          chave: "18266602-6085-4532-992d-7bc2750b19f4"
        },
        body: JSON.stringify({
          ...formData,
          feira_id: idFeira
        })
      });

      if (!response.ok) {
        const erro = await response.json();
        throw new Error(erro.message || "Erro ao enviar dados");
      }

      toast.success("Solicitação enviada com sucesso!");
      setShowModalConfirmado(true);

      setTimeout(() => {
        setFormData({});
        handleClose();
      }, 4000);
     
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!isModalOpen) {
      setFormData({});
      setIsBrasil(false);
      setShowModalConfirmado(false);
      setErrors({});
    }
  }, [isModalOpen]);

  return (
    <>
      <Modal style={{ animation: isModalOpen ? "showModal 1s ease" : "none", zIndex: 9999 }} isOpen={isModalOpen} centered>
              
        <ModalHeader toggle={handleClose}>Quero Expor</ModalHeader>
        <Form onSubmit={handleSubmit}>
          <ModalBody>
            <Row className="g-2">
              <Col lg={12}>
                <Label>Nome da Empresa*</Label>
                <Input 
                  name="nome_expositor" 
                  value={formData.nome_expositor || ''} 
                  onChange={handleChange}
                  invalid={!!errors.nome_expositor}
                />
                {errors.nome_expositor && <div className="text-danger small mt-1">{errors.nome_expositor}</div>}
              </Col>
              
              <Col lg={6}>
                <Label>País*</Label>
                <Input 
                  type="select" 
                  name="pais" 
                  value={formData.pais || ''} 
                  onChange={handleChange}
                  invalid={!!errors.pais}
                >
                  <option value="">Selecione...</option>
                  {listaPaisesFinal.map(p => <option key={p.sigla} value={p.sigla}>{p.nome}</option>)}
                </Input>
                {errors.pais && <div className="text-danger small mt-1">{errors.pais}</div>}
              </Col>
              
              <Col lg={6}>
                <Label>{isBrasil ? 'CNPJ*' : 'Código Internacional*'}</Label>
                {isBrasil ? (
                  <>
                    <InputMask 
                      mask="99.999.999/9999-99" 
                      value={formData.cnpj || ''} 
                      onChange={handleChange} 
                      name="cnpj"
                    >
                      {(inputProps) => <Input {...inputProps} invalid={!!errors.cnpj} />}
                    </InputMask>
                    {errors.cnpj && <div className="text-danger small mt-1">{errors.cnpj}</div>}
                  </>
                ) : (
                  <>
                    <Input 
                      name="codigo_internacional" 
                      value={formData.codigo_internacional || ''} 
                      onChange={handleChange}
                      invalid={!!errors.codigo_internacional}
                    />
                    {errors.codigo_internacional && <div className="text-danger small mt-1">{errors.codigo_internacional}</div>}
                  </>
                )}
              </Col>
              
              <Col lg={6}>
                <Label>E-mail*</Label>
                <Input 
                  name="email" 
                  value={formData.email || ''} 
                  onChange={handleChange}
                  invalid={!!errors.email}
                />
                {errors.email && <div className="text-danger small mt-1">{errors.email}</div>}
              </Col>
              
              <Col lg={6}>
                <Label>Telefone*</Label>
                <InputMask 
                  mask="(99) 99999-9999" 
                  value={formData.telefone || ''} 
                  onChange={handleChange} 
                  name="telefone"
                >
                  {(inputProps) => <Input {...inputProps} invalid={!!errors.telefone} />}
                </InputMask>
                {errors.telefone && <div className="text-danger small mt-1">{errors.telefone}</div>}
              </Col>

              {/* {isBrasil && ( */}
                <>
                  <Col lg={3}>
                    <Label>CEP</Label>
                    <Input 
                      value={formData.cep || ''} 
                      onChange={handleCepChange}
                      invalid={!!errors.cep}
                    />
                    {errors.cep && <div className="text-danger small mt-1">{errors.cep}</div>}
                  </Col>
                  
                  <Col lg={6}>
                    <Label>Cidade</Label>
                    <Input 
                      name="cidade" 
                      value={formData.cidade || ''} 
                      onChange={handleChange}
                      invalid={!!errors.cidade}
                    />
                    {errors.cidade && <div className="text-danger small mt-1">{errors.cidade}</div>}
                  </Col>
                  
                  <Col lg={3}>
                    <Label>Estado</Label>
                    <Input 
                      name="estado" 
                      value={formData.estado || ''} 
                      onChange={handleChange}
                      invalid={!!errors.estado}
                    />
                    {errors.estado && <div className="text-danger small mt-1">{errors.estado}</div>}
                  </Col>
                  
                  <Col lg={12}>
                    <Label>Rua</Label>
                    <Input 
                      name="rua" 
                      value={formData.rua || ''} 
                      onChange={handleChange}
                      invalid={!!errors.rua}
                    />
                    {errors.rua && <div className="text-danger small mt-1">{errors.rua}</div>}
                  </Col>
                  
                  <Col lg={6}>
                    <Label>Bairro</Label>
                    <Input 
                      name="bairro" 
                      value={formData.bairro || ''} 
                      onChange={handleChange}
                      invalid={!!errors.bairro}
                    />
                    {errors.bairro && <div className="text-danger small mt-1">{errors.bairro}</div>}
                  </Col>
                  
                  <Col lg={3}>
                    <Label>Número</Label>
                    <Input 
                      name="numero" 
                      value={formData.numero || ''} 
                      onChange={handleChange}
                      invalid={!!errors.numero}
                    />
                    {errors.numero && <div className="text-danger small mt-1">{errors.numero}</div>}
                  </Col>
                  
                  <Col lg={3}>
                    <Label>Complemento</Label>
                    <Input 
                      name="complemento" 
                      value={formData.complemento || ''} 
                      onChange={handleChange}
                    />
                  </Col>
                </>
              {/* )} */}

              <Col lg={12}>
                <Label>Área de Atuação</Label>
                <Input 
                  name="area_atuacao" 
                  value={formData.area_atuacao || ''} 
                  onChange={handleChange}
                />
              </Col>
              
              <Col lg={12}>
                <Label>Observações</Label>
                <Input 
                  type="textarea" 
                  name="observacao" 
                  rows={4} 
                  value={formData.observacao || ''} 
                  onChange={handleChange}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={handleClose}>Fechar</Button>
            <Button type="submit" color="success" disabled={isLoading}>
              {isLoading ? "Enviando..." : "Confirmar"}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={showModalConfirmado} centered backdrop="static">
        <ModalBody className="text-center">
          <h4 className="mt-3">Solicitação enviada!</h4>
          <p className="text-muted">Obrigado pelo contato.</p>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ModalQueroExpor;